module.exports = __webpack_public_path__ + "static/logo_comsuk-74daf7dab64390e657bbc9b14210cf3b.svg";